module.exports = __webpack_public_path__ + "static/media/S-task02_nodeLink.0f658255.png";